// Components==============
import ArrowButtons from 'components/UI/ArrowButtons/ArrowButtons';
import { useMediaQ } from 'hooks/useMediaQ';
import { ProcessContext } from 'components/UI/ProjectProcess/components/Process/Process';
import Token from 'components/UI/Token/Token';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useRef } from 'react';
import { AddActivityModalContext } from '../../AddActivityModal';
import './Process.module.scss';
// =========================

export default function Process() {
  const { phase } = useContext(ProcessContext);
  const {
    searchValue,
    fn,
    permission,
    usedActivities,
    usedPhases,
    handleAddSwitch,
    origin,
  } = useContext(AddActivityModalContext);

  const translate = useTranslate();
  const query = useMediaQ('min', 1024);

  const suggestionRef = useRef<HTMLDivElement>(null);

  const usedActivitiesSlugs = useRedux((state) =>
    usedActivities?.map((id) =>
      id ? state.activity?.entities.byId[id].slug : undefined
    )
  );

  const usedPhasesSlugs = useRedux((state) =>
    usedPhases?.map((id) =>
      id ? state.phase?.entities.byId[id].slug : undefined
    )
  );

  const selectedFreeActivities =
    usedActivitiesSlugs?.filter((slug) => slug?.includes('vrije-activiteit'))
      .length || 0;

  const suggestions = useRedux((state) =>
    state.activity?.entities.allIds
      .map((id) => state.activity?.entities.byId[id])
      .filter((a) => a?.type === 'regular')
      .filter((a) =>
        searchValue.length
          ? a?.name.toLowerCase().includes(searchValue.toLowerCase())
          : true
      )
      .filter((a) => a?.phases.includes(phase))
      .filter((a) => !usedActivities?.includes(a?.id))
  );

  const phases = useRedux((state) =>
    state.phase?.entities.allIds
      .map((id) => state.phase?.entities.byId[id])
      .filter((p) => p?.id !== 6 && p?.id !== 7)
      .filter((p) =>
        searchValue.length
          ? p?.name.toLowerCase().includes(searchValue.toLowerCase())
          : true
      )
  );

  const activities = useRedux((state) =>
    state.activity?.entities.allIds
      .map((id) => state.activity?.entities.byId[id])
      .filter((a) => a?.type === 'regular')
      // filter groowy
      .filter((a) => a?.id !== 1)
      // filter onbekend token
      .filter((a) => a?.slug !== 'onbekend')
      // filter checkpoint & herhaal bouwsteen in reflectie
      .filter((a) => origin === 'project' || (a?.id !== 2 && a?.id !== 3))
      .filter((a) =>
        searchValue.length
          ? a?.name.toLowerCase().includes(searchValue.toLowerCase())
          : true
      )
      .filter((a) => {
        if (a?.slug === 'vrije-activiteit' && selectedFreeActivities === 0)
          return true;

        if (a?.slug === 'vrije-activiteit-1' && selectedFreeActivities === 1)
          return true;

        if (
          a?.slug === 'vrije-activiteit-2' &&
          (selectedFreeActivities === 2 || selectedFreeActivities === 3)
        )
          return true;

        if (a?.slug.includes('vrije-activiteit')) return false;

        return true;
      })
  );

  return (
    <div styleName="wrapper">
      {!!suggestions?.length &&
        permission !== 'App\\Phase' &&
        origin === 'project' && (
          <div styleName="suggestion">
            <div styleName="title">
              <h3>{translate('project.terms.activity-suggestions')}</h3>
              <ArrowButtons reference={suggestionRef} />
            </div>
            <div styleName="grid" ref={suggestionRef}>
              {suggestions?.map(
                (e) =>
                  !!e && (
                    <Token
                      token={e}
                      key={e?.id}
                      style={{ maxWidth: 'initial' }}
                      handleAdd={
                        fn === 'add'
                          ? () => handleAddSwitch('App\\Activity', e)
                          : undefined
                      }
                      handleSwitch={
                        fn === 'switch'
                          ? () => handleAddSwitch('App\\Activity', e)
                          : undefined
                      }
                    />
                  )
              )}
            </div>
          </div>
        )}
      {!!phases?.length && origin === 'project' && (
        <div styleName="processteps">
          <div styleName="title">
            <h3>{translate('project.terms.phases')}</h3>
          </div>
          <div styleName="grid">
            {phases?.map(
              (p) =>
                !!p && (
                  <Token
                    key={p?.id}
                    token={p}
                    handleAdd={
                      fn === 'add'
                        ? () => handleAddSwitch('App\\Phase', p)
                        : undefined
                    }
                    handleSwitch={
                      fn === 'switch'
                        ? () => handleAddSwitch('App\\Phase', p)
                        : undefined
                    }
                    isUsed={
                      (usedPhasesSlugs?.filter((slug) => slug === p.slug)
                        .length || 0) >= 3
                    }
                    isPhase
                    mobileModal={!query}
                  />
                )
            )}
          </div>
        </div>
      )}
      {!!activities?.length && permission !== 'App\\Phase' && (
        <div styleName="activities">
          <div styleName="title">
            <h3>{translate('project.terms.activities')}</h3>
          </div>
          <div styleName="grid">
            {activities?.map(
              (activity) =>
                !!activity && (
                  <div
                    styleName={
                      activity?.name === 'Groowy'
                        ? 'Groowy'
                        : activity?.name === 'Checkpunt'
                        ? 'Checkpunt'
                        : ''
                    }
                    key={activity?.id}
                  >
                    <Token
                      token={activity}
                      handleAdd={
                        fn === 'add'
                          ? () => handleAddSwitch('App\\Activity', activity)
                          : undefined
                      }
                      handleSwitch={
                        fn === 'switch'
                          ? () => handleAddSwitch('App\\Activity', activity)
                          : undefined
                      }
                      isUsed={
                        activity.slug === 'herhaal'
                          ? usedActivitiesSlugs?.filter(
                              (slug) => slug === activity.slug
                            ).length === 3
                          : activity.slug === 'checkpunt'
                          ? usedActivitiesSlugs?.filter(
                              (slug) => slug === activity.slug
                            ).length === 3
                          : usedActivities?.includes(activity?.id)
                      }
                      mobileModal={!query}
                    />
                  </div>
                )
            )}
          </div>
        </div>
      )}
    </div>
  );
}
